import { Source } from 'core-lib/constants/sourceSKU';
import {
  validateCarwashProject,
  checkStoreLocationServiceable,
  checkCarWaxServiceable,
  checkCarCareServiceability,
} from '../services/allProductServiceableApi';
import { CommonPayload } from '../services/checkServiceability';

export const getServiceableApiByCategory = (category: string, payload: CommonPayload | any) => {
  switch (category) {
    case Source.CarCare:
    case Source.CarCareFullSpa:
    case Source.CarCareExterior:
    case Source.CarCareInterior:
    case Source.CarCareInteriorOnly:
      return checkCarCareServiceability(payload);

    case Source.CarWash:
      return validateCarwashProject(payload);

    case Source.CarWax:
      return checkCarWaxServiceable(payload);

    case Source.ParkplusStore:
      return checkStoreLocationServiceable(payload);
  }
};
